/**
 * Configuration object to handle application options.
 *
 * @object config
 */
var config = {
  keys: {
    SPACE: 32,
    RETURN: 13,
    TAB: 9,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
  },

  forms: {
    endpoint: {
      email:
        "https://2pwfhh8cw3.execute-api.us-east-1.amazonaws.com/stage/form-proxy/email",
      mailchimp:
        "https://2pwfhh8cw3.execute-api.us-east-1.amazonaws.com/stage/form-proxy/mailchimp",
      upload:
        "https://prpje5kxi8.execute-api.ca-central-1.amazonaws.com/dev/s3-upload/getSignedUrl",
    },
    regex: {
      text: /^([^0-9]*)$/,
      email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
      phone: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
    },
  },

  maps: {
    key: "AIzaSyAJDT3jKlz78yy7qZdpuHK9He2-9B1MvvQ", // Billing Account is managed by the client
  },
};
